import { SectionCard } from '@atlas/ui-components'
import { Spinner } from '@atlas/ui-primitives'
import { useWorkfrontOverview } from '@/hooks/useWorkfront'
import { apiErrorMessage } from '@/lib/api-error'
import { StreamsTable } from './components/StreamsTable'
import { WorkfrontHeader } from './shared'

/** The discovery streams: how far each has read and how far behind it is. They come with the overview. */
export function WorkfrontStreamsPage() {
	const overview = useWorkfrontOverview()
	return (
		<div className="space-y-6">
			<WorkfrontHeader title="Streams" />
			{overview.isLoading ? <Spinner aria-label="Loading the streams" /> : null}
			{overview.isError ? (
				<p className="text-ds-sm text-ds-danger">{apiErrorMessage(overview.error, 'Could not load the streams.')}</p>
			) : null}
			{overview.data ? (
				<SectionCard title="Discovery streams">
					<StreamsTable streams={overview.data.streams} />
				</SectionCard>
			) : null}
		</div>
	)
}
